import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getConfig from '../../../helpers/config';
import { SearchParams } from '../../../interfaces/global-search';
import { getPrepareHeaders } from '../get-prepare-headers';

const { test } = getConfig();

export const searchApi = createApi({
  reducerPath: 'search',
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['search'],
  endpoints: (builder) => ({
    getSearch: builder.mutation<string, SearchParams>({
      query: (body) => ({
        url: '/search',
        method: 'POST',
        body,
        responseHandler: (response) => response.json(),
      }),
    }),
  }),
});
export const { useGetSearchMutation } = searchApi;
